import Vue from 'vue'
import Vuex from 'vuex'

import auth from "./modules/auth.js";
import role from "./modules/role.js";
import contractType from "./modules/ContractType.js";
import documentType from "./modules/DocumentType.js";
import healthInsurance from "./modules/HealthInsurances.js";
import jobTitle from "./modules/JobTitle.js";
import professionalInsurance from "./modules/ProfessionalInsurances.js";
import client from "./modules/Clients.js";
import user from "./modules/User.js";
import setting from "./modules/Settings.js";
import dailyLettersReference from "./modules/DailyLettersReferences.js";
import dailyLettersReason from "./modules/DailyLettersReasons.js";
import dailyLettersAbsentGender from "./modules/DailyLettersAbsentGenders.js";
import product from "./modules/Products.js";
import clientStock from "./modules/ClientStock.js";
import stockOrder from "./modules/StockOrders.js";
import stockPurchaseOrder from "./modules/StockPurchaseOrders.js";
import stockReport from "./modules/StockReports.js";
import stockTask from "./modules/StockTasks.js";

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    overlay: false
  },
  getters:{  
    overlay(state){
      return state.overlay;
    }
  },
  mutations: {
    SET_OVERLAY(state, value){
      state.overlay = value;
    }
  },
  actions: {
  },
  modules: {
    auth,
    role,
    contractType,
    documentType,
    healthInsurance,
    jobTitle,
    professionalInsurance,
    client,
    user,
    setting,
    dailyLettersReference,
    dailyLettersReason,
    dailyLettersAbsentGender,
    product,
    clientStock,
    stockOrder,
    stockPurchaseOrder,
    stockReport,
    stockTask
  }
})
